import React, { ComponentProps } from "react";
import Button from "../Button/Button";

interface Props extends ComponentProps<typeof Button> {
    color?: "none";
}

/**
 * This component is used to render a button without any styling.
 * For instance, wrapping an icon.
 * This is a wrapper around our normal button component.
 * So it's a little easier to use in various places rather
 * than setting up configurations.
 */
const ButtonNoStyles = ({ size = "none", ...rest }: Props) => <Button {...rest} size={size} variant="none" />;

export default ButtonNoStyles;
